// =============================================================================
// src/config/api.js
// The ONE place where the frontend decides which backend to talk to.
//
//   1) REACT_APP_API_BASE_URL (or older names REACT_APP_API_URL / REACT_APP_BACKEND_URL)
//        https://api.hirsta.com   -> your own API domain (custom domain on the backend)
//        same-origin              -> the app's own address, e.g. https://app.hirsta.com/api/...
//                                    (Render frontend rewrites /api/* to the backend)
//   2) app opened on your own computer (localhost)  -> http://localhost:5001
//   3) app opened on the live site, nothing set     -> https://hirsta-api-1.onrender.com
//
// So the live site can never call localhost, even if an env value is missing at build time.
// =============================================================================

const LIVE_API = 'https://hirsta-api-1.onrender.com';
const LOCAL_API = 'http://localhost:5001';

/** Accepts "https://api.x.com", ".../api/v1", ".../api/v1/smiify/sm" or ".../api/v1/public" and keeps only the origin */
const toOrigin = (value) => String(value || '')
    .trim()
    .replace(/\/+$/, '')
    .replace(/\/api\/v1(?:\/(?:public|smiify\/sm))?$/, '')
    .replace(/\/+$/, '');

const isBrowser = typeof window !== 'undefined';
const onOwnComputer = isBrowser && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
const isLocalAddress = (url) => /\/\/(localhost|127\.0\.0\.1)(:|\/|$)/.test(url);

const rawEnv = String(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || '').trim();
const sameOrigin = /^(same-origin|self|\/)$/i.test(rawEnv);
let fromEnv = sameOrigin ? '' : toOrigin(rawEnv);
// A localhost value baked into a live build (e.g. from a committed .env) is ignored on the live site
if (fromEnv && isLocalAddress(fromEnv) && isBrowser && !onOwnComputer) {
    // eslint-disable-next-line no-console
    console.warn(`[config] Ignoring ${fromEnv} on the live site; using ${LIVE_API}. Fix REACT_APP_API_BASE_URL in Render > Environment.`);
    fromEnv = '';
}

export const API_ROOT = (sameOrigin && isBrowser && !onOwnComputer ? window.location.origin : '')
    || fromEnv
    || (onOwnComputer ? LOCAL_API : LIVE_API);
export const API_V1 = `${API_ROOT}/api/v1`;
export const SMIIFY_API = `${API_V1}/smiify/sm`;   // logged-in salon APIs
export const PUBLIC_API = `${API_V1}/public`;      // no-login APIs (public invoice link)

/** Address clients open (shared invoice links). Defaults to the current site. */
export const APP_URL = toOrigin(process.env.REACT_APP_PUBLIC_APP_URL) || (isBrowser ? window.location.origin : '');

export default API_ROOT;